// Vendor imports
const { connect } = require('react-redux')
// Common client-v2 imports
const ImmutableToJS = require('client-v2/common/components/immutable-to-js')
const userModelActions = require('client-v2/common/models/user/actions')
const { FetchStateEnum } = require('client-v2/common/utils/enums')
// Container state imports
const { getSlide } = require('../state/selectors')
const articleProfileSlideActions = require('../state/slide-actions')
// Sibling imports
const ArticleProfileComments = require('./comments-dumb')

function mapStateToProps(state, props) {
  const slide = getSlide(state, props)
  const isLoading = slide.commentsState === FetchStateEnum.LOADING
  return {
    // Flags
    isLoading,
    // Values
    article: slide.article,
    items: slide.commentsItems,
    user: state.user
  }
}

const mapDispatchToProps = {
  onFormSubmit: articleProfileSlideActions.addComment,
  onItemDelete: articleProfileSlideActions.deleteComment,
  onItemReport: articleProfileSlideActions.reportComment,
  onItemUserClick: userModelActions.navigateToUserProfile
}

// Exports

const SmartComponent = connect(
  mapStateToProps,
  mapDispatchToProps
)(
  ImmutableToJS(
    ArticleProfileComments
  )
)

module.exports = SmartComponent
